export default __webpack_public_path__ + "static/media/crm-liquidity.b5d7de82.svg";